import { Button, Modal } from 'antd';
import React, { FC, useState } from 'react';
import TroubleshootingDisplay from '../../common/TroubleshootingDisplay';
import { CheckCircleFilled, CheckCircleOutlined } from '@ant-design/icons';

interface TroubleshootingStepsPreviewModalProps {
	onCancel: () => void;
	troubleshootingSteps: any[];
}

const TroubleshootingStepsPreviewModal: FC<TroubleshootingStepsPreviewModalProps> = ({
	troubleshootingSteps,
	onCancel,
}) => {
	const [showEndStep, setShowEndStep] = useState(false);

	const _onNextStep = () => setShowEndStep(true);

	return (
		<Modal
			visible={true}
			width={'90%'}
			title=" "
			closable
			onCancel={onCancel}
			forceRender
			footer={null}
			style={{
				top: '5%',
				height: '90vh', // 100vh - (5% top + 5% bottom)
				padding: 0,
			}}
			bodyStyle={{
				minHeight: 'calc(90vh - 55px)', // subtract header/footer height
				overflow: 'auto',
				padding: 0,
			}}
		>
			<div className="troubleshooting-modal-priview">
				{showEndStep ? (
					<div className="my-[20%] flex flex-col items-center justify-center">
						<CheckCircleOutlined style={{ fontSize: '64px', color: 'green' }} />
						<h5 className="my-4">You've reached the end of all steps</h5>
						<Button type="primary" onClick={onCancel}>
							Exit Preview
						</Button>
					</div>
				) : (
					<TroubleshootingDisplay
						noStyle
						onNextStep={_onNextStep}
						troubleshootingSteps={troubleshootingSteps}
					/>
				)}
			</div>
		</Modal>
	);
};

export default TroubleshootingStepsPreviewModal;
